// extracted by mini-css-extract-plugin
export default {"container":"FinalRemark__container___KqGCA"};